module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"answer":"Answer","decline":"Decline"}}')
  delete Component.options._Ctor
}
